export const validationPatterns = {
  name: /^[A-Za-záéíóúÁÉÍÓÚÑñ\s]+$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  phone: /^[0-9]{10}$/,
  password:
    /^(?=.*[a-zñáéíóú])(?=.*[A-ZÑÁÉÍÓÚ])(?=.*\d)(?=.*[!@#$%^&*_-])[A-Za-zñÑáéíóúÁÉÍÓÚ\d!@#$%^&*_-]+$/,
  api: /^[a-zA-Z0-9_-]+$/,
  salesPointId: /^\d+$/,
  number: /^\d+$/,
  percentage: /^([1-9][0-9]?|100)$/,
  decimal: /^([1-9]?[0-9]|100)(,\d{1,2})?$/,
  numberWithString: /^[a-zA-Z0-9]*$/,
  vintage: /^\d{1,8}(,\d{1,2})?$/,
  energy: /^[a-zA-Z0-9\s]+(,\d{1,2})?$/,
};
